import React from "react";
import { Route} from "react-router-dom";
import auth from "./auth";

const PrivateRoute = ({
  path,
  layout:Layout,
  component: Component,
  brandingInfo: brandingInfo,
  ...rest
}) => (
  <Route exact path={path} render={(props) => {
    if (auth.isAuthenticated()) {
      return<Layout brandingInfo={brandingInfo}><Component {...props}{...rest} /></Layout>;
    }
      return null;
  }} />
);

export default PrivateRoute;
